import { Client } from '../api/clients';

export interface Property {
  id: string;
  name: string;
  address: string;
  state: string;
}

export interface PropertySearchProps {
  isHomePage: boolean;
  onNavigateToProperty?: (propertyId: string) => void;
  onSelectionChange?: (selectedProperties: Property[]) => void;
}

// Utility function to convert Client to Property
export const clientToProperty = (client: Client): Property => ({
  id: client.client_id,
  name: client.client_name,
  address: client.property_address,
  state: client.property_state,
});
